import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

const AuthPageHeader = ({ title, description = "Authentication page for BotBlogR" }) => {
  return (
    <Helmet>
      <title>{title} | BotBlogR</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

AuthPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default AuthPageHeader;
